import { Link, NavLink, Outlet } from "react-router-dom";
import React from "react";
import { Helmet } from "react-helmet";
import { useTranslation } from "react-i18next";
function StatsLayout() {
  const { t } = useTranslation();

  return (
    <>
      <Helmet>
        ‍<title>حسابي - محصول</title>‍
        <meta property="og:site_name" content="Mahsool" />
        <meta name="keywords" content="Mahsool" />
        <meta property="og:title" content="حسابي - محصول" />
        <meta property="og:description" content="mahsool" />
        <meta property="og:locale" content="en_US" />
        <meta property="og:type" content="website" />
      </Helmet>
      <div className="flex flex-col">
        <div className="stats mx-auto gap-2 text-center justify-between font-bold w-[70%] flex lg:w-[17rem] my-10 h-[44px] rounded-[20px] border-[#E7E7E7] border">
          <NavLink
            to="statistics"
            className=" w-full h-full lg:px-7 flex justify-center items-center rounded-[20px] transition duration-300 ease-out"
          >
            {/* اللإحصائيات */}
            {t("pricePage.statistics")}
          </NavLink>

          <NavLink
            to="updates"
            className="w-full h-full lg:px-7 rounded-[20px] flex justify-center items-center transition duration-300 ease-out"
          >
            {/* الأسعار */}
            {t("common.prices")}
          </NavLink>
        </div>
        <div>
          <Outlet />
        </div>
      </div>
    </>
  );
}

export default StatsLayout;
